export default __webpack_public_path__ + "static/media/my-home-i.c4223e8f.svg";